import {
    CLEAR_NOTIFICATIONS,
    SET_NOTIFICATION_DETAILS,
} from '../actions/notificationActions';

export function notificationReducer(prevState: any = {}, action: any = {}) {
    switch (action.type) {
        case SET_NOTIFICATION_DETAILS:
            return {
                ...prevState,
                notifications: [
                    ...prevState.notifications,
                    action.notificationDetails,
                ],
            };

        case CLEAR_NOTIFICATIONS:
            return { notifications: [] };
        default:
            return prevState;
    }
}
